import React from 'react';
import HeaderMenu from '../publicComponents/headerMenu';
import OtherFooterMenu from '../publicComponents/otherFooterMenu';
import BreadCrums from '../publicComponents/breadcrums';

export class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    };
  }

  handleSendMessage = event => {
    event.preventDefault();
    const { name, phone, subject, email, message } = this.state;
    const mailtoContent = `mailto:info@iaya.com?subject=${subject}&body=Name: ${name}%0D%0A%0D%0A Phone Number: ${phone} %0D%0A%0D%0A Email: ${email}%0D%0A%0D%0A  Message: ${message} %0D%0A%0D%0A`;
    window.location.href = mailtoContent;
    this.setState({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
    });
  };

  handleNameChange = event => {
    this.setState({
      name: event.target.value,
    });
  };
  handleEmailChange = event => {
    this.setState({
      email: event.target.value,
    });
  };
  handlePhoneChange = event => {
    this.setState({
      phone: event.target.value,
    });
  };
  handleSubjectChange = event => {
    this.setState({
      subject: event.target.value,
    });
  };
  handleMessageChange = event => {
    this.setState({
      message: event.target.value,
    });
  };
  render() {
    const { name, phone, subject, email, message } = this.state;
    return (
      <div>
        <HeaderMenu />
        <BreadCrums pageName='Contact' />
        <div className='wrapper'>
          <article className='article-padd-half bg-gray'>
            <div className='container'>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='pg-hd'>
                    <h3>Get in Touch</h3>
                  </div>
                </div>
                <div className='col-lg-3 col-md-12'>
                  <div className='location-wraper'>
                    <div className='add-wrap'>
                      <img src='images/location-icon.png' alt='' />
                      <p>
                        Jamia Khizra Masjid & Islamic Centre Parker Street,
                        Bury, BL9 0RJ
                      </p>
                    </div>
                    <div className='call-wrap'>
                      <img src='images/call-icon.png' alt='' />
                      <p>
                        <a href='tel:+01617636884'> 0161 763 6884 </a>
                      </p>
                    </div>
                    {/* <div className='email-wrap'>
                      <img src='images/email-icon.png' alt='' />
                      <p>
                        <a href='mailto:info@iaya.com'>info@iaya.com</a>
                      </p>
                    </div> */}
                    <div className='social-media'>
                      <h4>You can also connect us here.</h4>
                      <ul className='list-unstyled'>
                        <li>
                          <a href='' target='_blank'>
                            <img src='images/facebook.png' alt='' />
                          </a>
                        </li>
                        <li>
                          <a href='' target='_blank'>
                            <img src='images/twitter.png' alt='' />
                          </a>
                        </li>
                        <li>
                          <a href='' target='_blank'>
                            <img src='images/instagram.png' alt='' />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 col-md-12'>
                  <div className='map-img'>
                    <a
                      href='https://www.google.com/maps/place/Jamia+Khizra+Mosque/@53.5993163,-2.2923036,17z/data=!3m1!4b1!4m5!3m4!1s0x487ba4c5badf6db7:0x26a891d8f2d4e490!8m2!3d53.5993163!4d-2.2901149'
                      target='_blank'
                    >
                      <img
                        src='images/map-img.png'
                        alt=''
                        className='img-fluid'
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div className='form-sec'>
                <div className='row'>
                  <div className='col-md-12'>
                    <div className='pg-hd'>
                      <h3>Send us a message</h3>
                    </div>
                  </div>
                  <div className='col-md-8'>
                    <div className='form-wraper'>
                      <form action='' onSubmit={this.handleSendMessage}>
                        <div className='form-inline'>
                          <div className='form-group'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Name*'
                              value={name}
                              onChange={this.handleNameChange}
                            />
                          </div>
                          <div className='form-group'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Email*'
                              value={email}
                              onChange={this.handleEmailChange}
                            />
                          </div>
                        </div>
                        <div className='form-inline'>
                          <div className='form-group'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Phone*'
                              value={phone}
                              onChange={this.handlePhoneChange}
                            />
                          </div>
                          <div className='form-group'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Subject*'
                              value={subject}
                              onChange={this.handleSubjectChange}
                            />
                          </div>
                        </div>
                        <div className='form-group'>
                          <textarea
                            name=''
                            id=''
                            cols='30'
                            rows='7'
                            className='form-control'
                            placeholder='Message'
                            value={message}
                            onChange={this.handleMessageChange}
                          ></textarea>
                        </div>
                        <div className='form-group mb-0'>
                          <button className='btn btn-default'>Send</button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='side-img'>
                      <img
                        src='images/side-mosque.png'
                        alt=''
                        className='img-fluid'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
        <OtherFooterMenu />
      </div>
    );
  }
}
export default Contact;
